export default __webpack_public_path__ + "static/logo-8cfd1ee0a9925a9ca53d419a7e533aa5.png";